module.exports = __webpack_public_path__ + "static/media/19.fe089a12.png";